import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "@remix-run/react";

import { useOptionalUser } from "../../utils";
import { Button } from "../Button";

import { HeaderLogo } from "./HeaderLogo";

interface Props {
  matchCount?: number;
}

export function LogoOrBackButton({ matchCount }: Props) {
  const user = useOptionalUser();
  const location = useLocation();
  const isHome = location.pathname === "/";
  const navigate = useNavigate();

  function goBack() {
    if (history.length > 0) {
      return navigate(-1);
    }
    navigate("/");
  }

  if (!isHome && user) {
    return (
      <Button variant="ghost" onClick={goBack} className="p-0">
        <ArrowLeftIcon className="text-white h-4 w-4" />
        back
      </Button>
    );
  }

  return <HeaderLogo matchCount={matchCount} />;
}
